import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
 
const PrivateRoute = () => {
const token = localStorage.getItem('token');
const isOnboarded = localStorage.getItem('isOnboarded');
const isAuthenticated = !!token;
const location = useLocation();

if (!isAuthenticated) {
return <Navigate to="/login" replace state={{ from: location }} />;
}

// if(isAuthenticated && isOnboarded === false){
// return <Navigate to="/onboarding" replace state={{ from: location }} />;  
// }

return <Outlet />;
}; 

export default PrivateRoute;
